export default "__VITE_ASSET__f750c63e__"